import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  DASHBOARD_HERO_IMAGE6,
  PROFIT_IMAGE,
  LOSS_IMAGE,
  ARROW_DOWN,
  CONTACTINFO_IMG,
  VERIFYACCCOUNT_IMG,
  PROFILE_IMG,
  NOAVAILABILITYADDED,
  PROFILE_REJECTED,
} from "../../utils/aap-image-constant";

import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar/dist/cjs/Calendar.js";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  decryptAEStoJSON,
  LoaderSpinner,
  toastEmitter,
} from "../../utils/utilities";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { Link, useNavigate } from "react-router-dom";
import {
  getAllMatchingDashbaordfilter,
  getAllUpcomingAppointmentListByDate,
  getDoctorsCountByClinic,
  getSpecializationByClinic,
} from "../../hooks/services/api-services";
import { debounce } from "lodash";
import { API_RESPONSE } from "../../utils/app-constants";
import SimpleBarChart from "../../components/snippets/bar-chart";
import { convertAppointmentTimeToAMPM } from "../../utils/form-utils";
import dayjs from "dayjs";
import { API_URL } from "../../utils/url-constants";
const Dashboard = ({ setSidebarShow }) => {
  const [showCalander, setShowCalander] = useState(true);
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [eventList, setEventList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { value } = useSelector((state) => state?.loggedUser);
  const [patientData, setPatientData] = useState({});
  const userData = useMemo(() => decryptAEStoJSON(value), [value]);
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMatching, setIsLoadingMatchiing] = useState(false);
  const [SpecilalizationList, setSpecilalizationlist] = useState();
  const [selectedSpecialization, setSelectedSpecialization] = useState("");
  const [rowData, setRowData] = useState([]);
  const isFirstRender = useRef(true);
  const [chartData, setChartData] = useState([]);
  const [doctorCount, setDoctorCount] = useState(0);
  const [specializationList, setSpecializationList] = useState([]); // original list
  const [translatedList, setTranslatedList] = useState([]); // translated list

  const clinicId = userData?.id
  const languageType = i18n.language
  // const fetchSpecilalizationdata = async (clinicId, languageType) => {
  //   try {
  //     const response = await getSpecializationByClinic(clinicId, languageType);
  //     if (response?.data?.status === 200) {
  //       const plainList = response?.data?.data || [];
  //       const sortedList = plainList.sort((a, b) => a.localeCompare(b));
  //       setSpecilalizationlist(sortedList);
  //     }
  //   } catch (error) {
  //     toastEmitter("error", API_RESPONSE?.MESSAGE_503);
  //   }
  // };
  const fetchSpecializationData = async (clinicId, languageType) => {
    try {
      const response = await getSpecializationByClinic(clinicId, languageType);
      if (response?.data?.status === 200) {
        const { original = [], translated = [] } = response?.data?.data || {};

        // Merge into one list to preserve mapping
        const mergedList = original.map((orig, i) => ({
          original: orig,
          translated: translated[i] || orig, // fallback to English if translation missing
        }));

        // Sort by original (or translated, based on requirement)
        const sortedList = mergedList.sort((a, b) =>
          a.original.localeCompare(b.original)
        );

        setSpecializationList(sortedList); // keep merged list
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  useEffect(() => {
    if (userData?.id && languageType) {
      fetchSpecializationData(userData.id, languageType);
    }
  }, [userData.id, languageType]);

  const fetchAppointments = async (clinicId, date) => {
    try {
      setLoading(true);
      const formattedDate = date.toLocaleDateString("en-CA");
      const response = await getAllUpcomingAppointmentListByDate(
        clinicId,
        formattedDate,
        i18n.language
      );
      if (response?.data?.status === 200) {
        setEventList(response?.data?.data || []);
      } else {
        setEventList([]);
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      setEventList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDate && clinicId) {
      fetchAppointments(clinicId, selectedDate);
    }
  }, [selectedDate, clinicId, i18n.language]);

  // const selectedSpecializationObj =
  //   selectedSpecialization === ""
  //     ? SpecilalizationList // all specializations
  //     : SpecilalizationList?.filter((item) => item === selectedSpecialization);

  // const payload = {
  //   clinicId: userData?.id,
  //   specialization: selectedSpecializationObj || [],
  // };

  const selectedSpecializationObj =
    selectedSpecialization === ""
      ? specializationList.map((item) => item.original) // all originals
      : [selectedSpecialization]; // already string original

  const payload = {
    clinicId: userData?.id,
    specialization: selectedSpecializationObj,
    languageType:i18n.language
  };


  // const fetchgetMatchingData = async () => {
  //   setIsLoadingMatchiing(true);
  //   try {
  //     const response = await getAllMatchingDashbaordfilter(payload);
  //     if (response?.data?.status !== 200) {
  //       if (isFirstRender.current) {
  //       }
  //       setRowData([]);
  //     } else {
  //       setRowData(response?.data?.data?.doctorResponseList);
  //       setIsLoadingMatchiing(false);
  //     }
  //   } catch (err) {
  //     setIsLoadingMatchiing(false);
  //     if (isFirstRender.current) {
  //     }
  //   } finally {
  //     setIsLoadingMatchiing(false);
  //     isFirstRender.current = false;
  //   }
  // };

  // const debouncedFetchData = debounce(fetchgetMatchingData, 500); // 500ms

  // useEffect(() => {
  //   if (SpecilalizationList && SpecilalizationList.length > 0) {
  //     debouncedFetchData();
  //   }
  //   return () => debouncedFetchData.cancel();
  // }, [SpecilalizationList, selectedSpecialization]);


  // doctor and patient count and chart data 


  const fetchgetMatchingData = async () => {
    setIsLoadingMatchiing(true);
    try {
      const selectedSpecializationObj =
        selectedSpecialization === ""
          ? specializationList.map((item) => item.original) // all originals
          : [selectedSpecialization]; // already original because dropdown value=original

      const payload = {
        clinicId: userData?.id,
        specialization: selectedSpecializationObj,
        languageType:i18n.language
      };

      const response = await getAllMatchingDashbaordfilter(payload);

      if (response?.data?.status !== 200) {
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.doctorResponseList || []);
      }
    } catch (err) {
      console.error("Error fetching matching data:", err);
    } finally {
      setIsLoadingMatchiing(false);
      isFirstRender.current = false;
    }
  };

  const debouncedFetchData = debounce(fetchgetMatchingData, 500);

  useEffect(() => {
    if (specializationList && specializationList.length > 0) {
      debouncedFetchData();
    }
    return () => debouncedFetchData.cancel();
  }, [specializationList, selectedSpecialization]);

  const fetchDoctorsCountData = async () => {
    setIsLoading(true);
    try {
      const response = await getDoctorsCountByClinic(clinicId);
      const data = response?.data?.data;
      setPatientData(data?.patientCountResponse || {});
      const result = data?.specializationResponseList || [];

      const formattedData = result.map((item) => ({
        name:
          item.specializationName.length > 10
            ? item.specializationName.slice(0, 10) + "…"
            : item.specializationName,
        fullName: item.specializationName,
        Count: item.count,
      }));

      setDoctorCount(data?.doctorsCount || 0);
      setChartData(formattedData);

    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      return;
    } finally {
      setIsLoading(false); // END
    }
  };
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (clinicId) fetchDoctorsCountData();
    }
  }, [clinicId]);



  //  patient count and percentage logic start
  const onlineCount = patientData?.onlineCount || 0;
  const offlineCount = patientData?.offlineCount || 0;
  const totalCount = onlineCount + offlineCount;
  const onlinePercentage =
    totalCount > 0 ? (onlineCount / totalCount) * 100 : 0;
  const offlinePercentage =
    totalCount > 0 ? (offlineCount / totalCount) * 100 : 0;
  let onlineColorClass = 'bg-green-normal color-green-bold';
  let offlineColorClass = 'bg-green-normal color-green-bold';
  let onlineImage = PROFIT_IMAGE;
  let offlineImage = PROFIT_IMAGE;
  if (onlinePercentage > offlinePercentage) {
    onlineColorClass = 'bg-green-normal color-green-bold';
    offlineColorClass = 'bg-red-normal color-red-bold';
    onlineImage = PROFIT_IMAGE;
    offlineImage = LOSS_IMAGE;
  } else if (onlinePercentage < offlinePercentage) {
    onlineColorClass = 'bg-red-normal color-red-bold';
    offlineColorClass = 'bg-green-normal color-green-bold';
    onlineImage = LOSS_IMAGE;
    offlineImage = PROFIT_IMAGE;
  } else {
    onlineColorClass = 'bg-green-normal color-green-bold';
    offlineColorClass = 'bg-green-normal color-green-bold';
    onlineImage = PROFIT_IMAGE;
    offlineImage = PROFIT_IMAGE;
  }
  //  patient count and percentage logic end
  const getTimeBasedGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 17) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };
const StatusCard = ({ img, text, subText }) => {
  return (
    <div className="text-center">
      <img
        src={img}
        alt="status"
        className="img-fluid mb-2 verifyimage"
      />
      <p className="fs-16 fw-600 text-muted">{text}</p>
      {subText && (
        <p className="fs-14 text-muted">{subText}</p>
      )}
    </div>
  );
};
const country = userData?.country?.toLowerCase();

const isSaudi =
  country === "saudi arabia" || country === "sa";

const usesStripe = !isSaudi; // baki sab Stripe

  return (
    <>
      <>
        {(userData && userData?.isVerified === 2) ||
          userData?.isVerified === 3 ||
          userData?.isVerified === 4 ||
          userData?.isVerified === 5 ? (
          <p
            className={` mb-2  my-md-0 my-2  flex-wrap gap-1 dashboardgmtext d-flex justify-content-center align-items-center  text-center justify-content-md-start boardgmtext color-black-normal ${i18n.language === "ar" ? "pe-1" : ""
              }`}
          >
            {t(getTimeBasedGreeting())}
            <span className=" dashboardtext fw-600 color-blue ">
              {userData && userData?.clinicName}
            </span>
          </p>
        ) : (
          ""
        )}

        {userData && userData?.isVerified === 2 ? (
          <div className="container text-center d-flex justify-content-center align-items-center" style={{ minHeight: "75vh" }}>
            <div className="">
              <img
                className="img-fluid mb-2 verifyimage "
                src={VERIFYACCCOUNT_IMG}
                alt="contactinfo"
              />
              <p className="fs-16 mb-3 fw-600 text-muted">
                {t("Your Account Has Yet To Be Verified")}
              </p>
            </div>
          </div>
        ) :
         userData?.isVerified === 4 ? (
          <div
            className="container text-center d-flex justify-content-center align-items-center"
            style={{ minHeight: "75vh" }}
          >
            {userData?.contractAdmin === null ? (
              <div className="">
                <img
                  className="img-fluid mb-2 verifyimage "
                  src={CONTACTINFO_IMG}
                  alt="contactinfo"
                />
                <p className="fs-16 mb-3 fw-600 text-muted">
                  {t("Please wait while the contract is being uploaded by the admin.")}
                </p>
              </div>
            ) : (
              <div className="">
                <img
                  className="img-fluid mb-2 verifyimage "
                  src={CONTACTINFO_IMG}
                  alt="contactinfo"
                />
                <p className="fs-16 mb-3 fw-600 text-muted">
                  {t("Please Add Your Bank Information And Contract")}
                </p>
                <button
                  className="btnbackground textcolor rounded textfont14 border-0 px-5 py-2 "

                  onClick={() => {
                    navigate(ROUTES?.ADDBANKANDCONTRACT)
                  }}
                >
                  {t("Finish Setup")}
                </button>
              </div>
            )
            }
          </div>
        ) 
        : userData && userData?.isVerified === 5 ? (
          // <div
          //   div
          //   className="container text-center d-flex justify-content-center align-items-center"
          //   style={{ minHeight: "75vh" }}
          // >
          //   <div className="">
          //     <img
          //       className="img-fluid mb-2 verifyimage "
          //       src={VERIFYACCCOUNT_IMG}
          //       alt="contactinfo"
          //     />
          //     <p className="fs-16 mb-3 fw-600 text-muted">
          //       {t("Your Contract Has Yet To Be Verified")}
          //     </p>
          //   </div>
          // </div>
           <div className="container text-center d-flex align-items-center justify-content-center" style={{ minHeight: "75vh" }}>

        {/* Contract not uploaded */}
        {!userData?.contractAdmin && (
          <StatusCard
            img={CONTACTINFO_IMG}
            text="Please wait while admin uploads your contract"
          />
        )}

        {/* Contract uploaded → bank not added */}
        {userData?.contractAdmin &&
          !userData?.bankDetailsResponseList && (
            <div>
              <StatusCard
                img={CONTACTINFO_IMG}
                text="Please add your bank details to continue"
              />
              <button
                className="btnbackground px-5 py-2"
                onClick={() => navigate(ROUTES.ADDBANKANDCONTRACT)}
              >
                {t("Finish Setup")}
              </button>
            </div>
          )}

        {/* Bank added → Stripe pending */}
        {/* {userData?.bankDetailsResponseList &&
          userData?.stripeOnboarded === false && (
            <StatusCard
              img={CONTACTINFO_IMG}
              text="Stripe onboarding email sent. Please complete verification."
              subText="Check your email to create & verify your Stripe account."
            />
          )}

        {userData?.stripeOnboarded === true && (
          <StatusCard
            img={VERIFYACCCOUNT_IMG}
            text="Stripe account verified successfully"
            subText="Please wait for final admin approval"
          />
        )} */}
        {usesStripe &&
  userData?.bankDetailsResponseList &&
  userData?.stripeOnboarded === false && (
    <StatusCard
      img={CONTACTINFO_IMG}
      text="Stripe onboarding email sent. Please complete verification."
      subText="Check your email to create & verify your Stripe account."
    />
)}

{(isSaudi || userData?.stripeOnboarded === true) && (
  <StatusCard
    img={VERIFYACCCOUNT_IMG}
    text="Account setup completed"
    subText="Please wait for final admin approval"
  />
)}

      </div>
        ) : userData && userData?.isVerified === 3 ? (
          <div
            div
            className="container text-center d-flex justify-content-center align-items-center"
            style={{ minHeight: "75vh" }}
          >
            <div className="">
              <img
                className="img-fluid mb-2 verifyimage "
                src={PROFILE_REJECTED}
                alt="contactinfo"
              />
              <p className="fs-16  fw-600 text-muted">
                {t("Your profile Has been rejected")}
              </p>
              <p className="fs-16  fw-600 text-muted">
                Reason:-
                <span className=" text-danger"> {userData?.remark}</span>
              </p>
              <p className="fs-16 mb-3 fw-600 text-muted">
                {t("Please Contact to doctor and patient support team")}
                <Link> supportmedier@gmail.com</Link>
              </p>
            </div>
          </div>
        ) : userData && userData.isVerified === 1 && userData.suscribed === false ? (
          <div
            className="container text-center d-flex justify-content-center align-items-center"
            style={{ minHeight: "75vh" }}
          >
            <div className="">
              <img
                className="img-fluid mb-2 verifyimage "
                src={CONTACTINFO_IMG}
                alt="contactinfo"
              />
              <p className="fs-16 mb-3 fw-600 text-muted">
                {t("Please take a subscription to access the application.")}
              </p>
              <button
                className="btnbackground textcolor rounded textfont14 border-0 px-5 py-2 "
                onClick={() => {
                  navigate(ROUTES?.SUBSCRIPTION)
                }}
              >
                {t("Take Subscription")}
              </button>
            </div>
          </div>
        )

          : (
            <div className="  pb-2 m-0 " onClick={() => setSidebarShow(false)}>
              <div className="row ">
                <div className={`col-lg-8 `}>
                  <p
                    className={` mb-2 my-md-0 my-2 gap-2 flex-wrap  dashboardgmtext color-black-normal  d-flex justify-content-center align-items-center  text-center justify-content-sm-start ${i18n.language === "ar" ? "pe-1" : ""
                      }`}
                  >
                    {t(getTimeBasedGreeting())}
                    <span className=" dashboardtext fw-bold color-blue ">
                      {userData && userData?.clinicName} !
                    </span>
                  </p>
                  {/* HERO CARD  */}
                  <div className="">
                    <div className="row m-0">
                      <div className="col-12 p-0  dashboard-hero-card rounded-22">
                        <div className="row p-3  m-0 gx-5 ">
                          <div className="col-xl-8 p-0 ">
                            <p className=" fs-22 fw-600 mb-1">
                              {t("Total Patients")}
                            </p>
                            <h4 className="fw-600 fs-55 ">
                              {patientData?.patientCount || 0}
                            </h4>
                            <div className="row m-0 mt-md-5 mt-2 ">
                              {/* FIRST PROFIT ONLINE CARD */}
                              <div
                                className={`col-xl-5   p-3 me-0 me-xl-3 mb-3 mb-xl-0  bg-half-white rounded-4 card h-100 border-0  ${i18n.language === "ar" ? "me-lg-0" : " "
                                  }`}
                              >
                                <p className="fs-6 fw-600 text-capitalize letter-spacing-1 mb-3">
                                  {t("Online")}
                                </p>
                                <div className="d-flex justify-content-between align-items-center">
                                  <h4 className=" fs-2 fw-600 ">
                                    {patientData?.onlineCount || 0}
                                  </h4>
                                  <div
                                    className={` px-3 py-1 ms-3 rounded-3 text-center ${onlineColorClass}  fs-12 m-0 d-flex ${i18n.language === "ar"
                                      ? "flex-row-reverse"
                                      : "flex-row"
                                      }`}
                                  >
                                    <span className="pe-2 fw-medium">
                                      <span className="pe-2 fw-medium">
                                        {onlinePercentage.toFixed(0)}%
                                      </span>
                                    </span>{" "}
                                    <img
                                      className=""
                                      src={onlineImage}
                                      alt="icon"
                                      width={20}
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* SECOND LOSS OFFLINE CARD */}
                              <div
                                className={`col-xl-5 mx-xl-3 mx-0 mb-3 mb-xl-0 p-3  bg-half-white  rounded-4 card h-100 border-0  ${i18n.language === "ar" ? "me-0" : ""
                                  }`}
                              >
                                <p className="fs-6 fw-600 text-capitalize letter-spacing-1 mb-3">
                                  {t("Offline")}
                                </p>
                                <div className="d-flex justify-content-between align-items-center">
                                  <h4 className="fs-2 fw-600">
                                    {patientData?.offlineCount || 0}
                                  </h4>
                                  <div
                                    className={` px-3 py-1 rounded-3 text-center  ${offlineColorClass} fs-12 m-0  d-flex ${i18n.language === "ar"
                                      ? "flex-row-reverse"
                                      : "flex-row"
                                      }`}
                                  >
                                    <span className="pe-2 fw-medium">
                                      <span className="pe-2 fw-medium">
                                        {offlinePercentage.toFixed(0)}%
                                      </span>
                                    </span>{" "}
                                    <img src={offlineImage} alt="icon" width={20} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4 d-none d-xl-block position-relative">
                            <img
                              src={DASHBOARD_HERO_IMAGE6}
                              alt="icon"
                              srcSet=""
                              className="z-index-1 position-absolute top-50 start-50 dashboard-hero-img"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CHART CARD */}
                  <div>
                    <div className="row m-0 mt-4 mb-3 bg-white  border rounded-22 p-2">
                      <div className="col-12 m-0 p-2">
                        <p className=" fs-22 fw-600 mb-1">{t("Total Doctors")}</p>
                        {isLoading ? (
                          <div className="d-flex justify-content-center py-5">
                            <LoaderSpinner />
                          </div>
                        ) : (
                          <SimpleBarChart chartData={chartData} doctorCount={doctorCount} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-4 mt-3 mb-3"
                >
                  <div className="px-3  border bg-white rounded-22 ">
                    <div
                      className="d-flex justify-content-between  mt-3 align-items-center mb-3 cursor-pointer"
                      onClick={() => {
                        setShowCalander((prev) => !prev);
                      }}
                    >
                      <h3 className="text-center fs-18 fw-600 letter-spacing-2 text-capitalize m-0">
                        {t("My matching")}
                      </h3>
                    </div>
                    {/* <div className="col-md-12 ">
                      <select
                        className="form-select fs-14"
                        value={selectedSpecialization}
                        onChange={(e) =>
                          setSelectedSpecialization(e.target.value)
                        }
                      >
                        <option value="">{t("Select Specializations")}</option>
                        {SpecilalizationList &&
                          SpecilalizationList.length > 0 &&
                          SpecilalizationList?.map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                      </select>
                    </div> */}
                    <div className="col-md-12">
                      <select
                        className="form-select fs-14"
                        value={selectedSpecialization}
                        onChange={(e) => setSelectedSpecialization(e.target.value)}
                      >
                        <option value="">{t("Select Specializations")}</option>
                        {specializationList.map((item, index) => (
                          <option key={index} value={item.original}>
                            {item.translated}
                          </option>
                        ))}
                      </select>

                    </div>


                    <div className="d-flex justify-content-between  align-items-center ">

                      <div
                        className={`d-flex mt-2 ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
                          }`}
                      >
                      </div>
                    </div>
                    <div>
                      <div
                        className="row  align-items-start m-0  specelist_content overflow-auto cursor-pointer"
                        style={{ height: "232px" }}
                      >
                        {isLoadingMatching ? (
                          <div className="d-flex justify-content-center align-items-start w-100 py-5">
                            <LoaderSpinner />
                          </div>
                        ) : rowData?.length === 0 ? (
                          <div className="text-center mt-5">
                            <img
                              src={NOAVAILABILITYADDED}
                              alt="icon"
                              className="modelsuccessimg mb-3"
                            />
                            <h2 className="tableheading fs-18 mb-3 fw-500">
                              {t("My matching no found !")}
                            </h2>
                          </div>
                        ) : (
                          <div className="d-flex p-0 gap-2 flex-column py-2">
                            {rowData &&
                              rowData.length > 0 &&
                              rowData.map((match) => {
                                return (
                                  <div
                                    key={match.key}
                                    className="d-flex justify-content-between align-items-center "
                                    style={{
                                      minHeight: "48px",

                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-center">
                                      <div
                                        className={`rounded-circle border-sky-blue ${i18n.language === "ar"
                                          ? "ms-2"
                                          : "me-2 "
                                          }`}
                                      >

                                        <div
                                          className="rounded-circle overflow-hidden rounded-circle"
                                        >
                                          <img
                                            src={match?.image ? `${API_URL?.ServerURL}${match?.image}` : PROFILE_IMG}
                                            alt=""
                                            style={{
                                              objectFit: "cover", objectPosition: "center", width: "32px",
                                              height: "32px", padding: "2px", borderRadius: "50%",
                                            }}

                                          />
                                        </div>
                                      </div>
                                      <div style={{ lineHeight: "15px" }}>
                                        <p className="fs-14 fw-600 mb-0">
                                          {match?.firstName} {match?.lastName}
                                        </p>
                                        <p className="fs-12 letter-spacing-1 text-capitalize m-0">
                                          {t(match?.specialization)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border mt-4 rounded-22 px-3">
                    <div
                      className="d-flex justify-content-between mt-3 align-items-center mb-3 cursor-pointer"
                      onClick={() => setShowCalander((prev) => !prev)}
                    >
                      <h3 className="text-center fs-20 fw-600 letter-spacing-2 text-capitalize m-0">
                        {t("Calendar")}
                      </h3>
                      <div>
                        <img
                          src={ARROW_DOWN}
                          alt="ARROW_DOWN"
                          className={showCalander ? "rotate-0" : "rotate-180"}
                        />
                      </div>
                    </div>

                    {showCalander && (
                      <Calendar
                        className="w-100 border-0"
                        locale={i18n.language}
                        onChange={setSelectedDate}
                        value={selectedDate}
                        minDate={today}
                      />
                    )}

                    <div className="d-flex justify-content-between mt-3 align-items-center mb-4 cursor-pointer">
                      <h3 className="text-center fs-20 fw-600 letter-spacing-2 text-capitalize">
                        {t("Upcoming")} {t("Appointment")}
                      </h3>
                      <p className="text-primary fs-13 fw-500" onClick={() => navigate(ROUTES?.APPOINTMENT)}>{t("View All")}</p>
                    </div>

                    <div
                      style={{ height: "210px" }}
                      className="overflow-auto mb-3 specelist_content"
                    >
                      {loading ? (
                        <div className="d-flex justify-content-center align-items-start w-100 py-5">
                          <LoaderSpinner />
                        </div>
                      ) : eventList.length > 0 ? (
                        eventList.map((event) => {
                          const doctor = event.doctorResponse;
                          const fullName = `${doctor?.firstName || ""} ${doctor?.lastName || ""
                            }`;
                          const specialization = doctor?.specialization || "";
                          const appointmentDate = dayjs(
                            event?.appointmentDate
                          ).format("DD MMM YYYY");
                          const time = convertAppointmentTimeToAMPM(
                            event.appointmentStartingTime,
                            event.appointmentEndingTime
                          );

                          return (
                            <div
                              key={event.id}
                              className="p-2 rounded-3 d-flex gap-2 mb-2"
                              style={{ backgroundColor: "#F0F9FD" }}
                            >
                              {doctor?.image ? (
                                <img
                                  src={doctor.image}
                                  alt="doctor"
                                  style={{
                                    height: "36px",
                                    width: "36px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  className="bg-blue rounded-circle d-flex justify-content-center align-items-center text-white fs-6"
                                  style={{ height: "36px", width: "36px" }}
                                >
                                  {doctor?.firstName?.charAt(0)}
                                </div>
                              )}
                              <div>
                                <p className="fs-14 fw-500 mb-1">
                                  Dr. {fullName} ({specialization})
                                </p>
                                <p className="fs-12 text-muted mb-0">
                                  {appointmentDate} | {time}
                                </p>

                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center mt-md-5 mt-3">
                          <img
                            src={NOAVAILABILITYADDED}
                            alt="icon"
                            className="modelsuccessimg mb-2"
                          />
                          <h2 className="tableheading fs-18 mb-2 fw-500">
                            {t("No upcoming appointments found")} !
                          </h2>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

      </>
    </>
  );
};

export default Dashboard;
